import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { snakeCase } from 'lodash'
import { Text } from 'shared/components/Text/Text'

import { SnakeToCamelCase } from '../../../helpers/typeHelper'
import { PermissionType } from '../../../models/permission'
import { User } from '../../../models/user'

interface UserPermissionsProps {
  user: User
}

export function UserAppPermissions({ user }: UserPermissionsProps) {
  const { permissions } = user
  if (!permissions) return null

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Text variant="header3">Permission</Text>
              </TableCell>
              <TableCell>
                <Text variant="header3">Enabled</Text>
              </TableCell>
              <TableCell>
                <Text variant="header3">Message</Text>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(permissions).map((permission) => {
              const perm = permissions[permission as SnakeToCamelCase<PermissionType>]
              return (
                <TableRow key={permission}>
                  <TableCell>
                    <Text variant="label3">{snakeCase(permission)}</Text>
                  </TableCell>
                  <TableCell>
                    <Checkbox disabled checked={perm.enabled} />
                  </TableCell>
                  <TableCell>
                    <Text variant="label3">{perm.reason}</Text>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
